$.widget("custom.ticketgiftform", {
    options: {
    },
    _create: function () {
        var $widget = this,
            $this = $widget.element,
            $email = $("#FormData_ReceiverEmailAddress", $this).parents(".form-group"),
            $mobile = $("#FormData_ReceiverMobile", $this).parents(".form-group");

        $("input[name='FormData.ReceiverResponseType']", $this).change(function () {
            if ($(this).val() === "Email") {
                if(!$email.is(":visible")){
                    $mobile.fadeOut(200, function () {
                        $email.fadeIn(200);
                    });
                }
            }
            else {
                if (!$mobile.is(":visible")) {
                    $email.fadeOut(200, function () {
                        $mobile.fadeIn(200);
                    });

                }
            }
        });

    }
});
